/**
 * A rich-text body longer than this clips with a "Read more". The view models
 * carry the full source text; the renderer (`PostTextBody`) decides truncation
 * against this limit at render — nothing is baked into the view model.
 */
export const POST_PREVIEW_CHAR_LIMIT = 500;

/** Whether sanitized rich-text HTML is long enough to clip in a feed row. */
export function isBodyTruncatable(bodyHtml: string): boolean {
  return (
    bodyHtml.replace(/<[^>]*>/g, '').trim().length > POST_PREVIEW_CHAR_LIMIT
  );
}
